"use strict";


var LoggerInstance = require("js-logger").get("EmailSubscriptionActions");

var AccountFormHelper = require("../accountComponents/AccountFormHelper");

var ActionsHelper = require("../actions/ActionsHelper");

var AccountApi = require("../api/AccountApi");
var EmailSubscriptionApi = require("../api/EmailSubscriptionApi");

var Spinner = require("../client/Spinner");

var SubmitButtonHelper = require("../commonComponents/SubmitButtonHelper");
var ValidationHelper = require("../commonComponents/ValidationHelper");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var WizardStore = require("../designer/wizard/WizardStore");

var Dispatcher = require("../dispatcher/Dispatcher");

var BootstrapPrompt = require("../shared/BootstrapPrompt");
var HistoryHelper = require("../shared/HistoryHelper");

var EmailSubscriptionStore = require("../stores/EmailSubscriptionStore");

var EmailSubscriptionActions = {
	getDefaultEmailSubscriptionTypes() {
		return WizardStore.getValue("emailSubscriptions");
	},

	getEmailSubscriptionFormError(failedSubscriptions) {
		return EmailSubscriptionStore.getWizardValue(
			WizardConstants.WIZARDS.EMAIL_SUBSCRIPTION_MESSAGES,
			WizardConstants.EMAIL_SUBSCRIPTION_MESSAGE_FIELDS.EMAIL_SUBSCRIPTION_FORM_ERROR
		);
	},

	getMyEmailSubscriptionError(failedSubscriptions) {
		return EmailSubscriptionStore.getWizardValue(
			WizardConstants.WIZARDS.EMAIL_SUBSCRIPTION_MESSAGES,
			WizardConstants.EMAIL_SUBSCRIPTION_MESSAGE_FIELDS.MY_EMAIL_SUBSCRIPTIONS_ERROR,
			{ failedSubscriptions }
		);
	},

	initializeEmailSubscriptionForm: function (options) {
		options = options || {};

		var action = Object.assign({}, options, { actionType: Constants.EMAIL_SUBSCRIPTION_INITIALIZE });
		Dispatcher.dispatch(action);

		document.addEventListener("DOMContentLoaded", (event) => {
			var $subscriptionForms = $("[data-component='emailSubscriptionForm']");
			$subscriptionForms.each((index, component) => {
				var $component = $(component);
				var componentId = $component.attr("id");
				var $form = $component.find(`form#emailSubscriptionForm`).first();

				if (!options.isDesignMode) {
					// We need to make the form id and the submit button form attributes unique.
					var formId = $form.attr("id");
					var $submitButton = $form.find("[data-component='submitButton']");

					var newId = `${formId}_${componentId}`;

					$form.attr("id", newId);
					$submitButton.attr("form", newId);
				}

				$form.off("submit.emailSubscriptionForm");
				$form.on("submit.emailSubscriptionForm", EmailSubscriptionActions.submitEmailSubscriptionRequest.bind(this));

				if (options.isDesignMode) {
					return;
				}

				$component.find("[name][type='checkbox']").change((event) => {
					if (!event || !event.target) {
						return;
					}
					$(event.target).toggleClass("isDirty");

					var $selectedComponent = $(event.target);
					if ($selectedComponent.closest('[data-component="emailSubscriptionTypes"]').length) {
						EmailSubscriptionActions.updateSelectedCheckboxes($selectedComponent, $selectedComponent.is(":checked"));
					}
				});

				//Update the create account form inside of email subscriptions
				$component.find(`form#createAccountForm`).each((index, accountForm) => {
					var $accountForm = $(accountForm);

					var accountFormId = $accountForm.attr("id");

					var accountFormNewId = `${accountFormId}_${componentId}`;

					$accountForm.attr("id", accountFormNewId);
				});

				// Check and mark-as-selected the first checkbox.
				var $firstComponent = $component
					.find('[data-component="emailSubscriptionTypes.singleCheckbox.input"]:not(:disabled)').first();
				$firstComponent.prop("checked", true);
				EmailSubscriptionActions.updateSelectedCheckboxes($firstComponent, /* isChecked */true);
			});
		});
	},

	initializeMyEmailSubscriptions: function (options) {
		// init store
		var action = Object.assign({}, options, { actionType: Constants.EMAIL_SUBSCRIPTION_INITIALIZE });
		Dispatcher.dispatch(action);

		var $form = options.form || $("[data-component='myEmailSubscriptions']");
		if (!$form.length) {
			return;
		}

		var $submitForm = $form.find("form").first();

		$submitForm.off("submit.myEmailSubscriptions");
		$submitForm.on("submit.myEmailSubscriptions", event => this.submitAccountEmailSubscriptions(event));

		if (!options.isDesignMode) {
			// fetch all email subscriptions for this user, check ones we're subscribed to.
			EmailSubscriptionApi.getEmailSubscriptions().done(data => {
				if (data && data.items) {
					data.items.forEach(item => {
						var $input = $form.find(`input[data-component='emailSubscriptionTypes.singleCheckbox.input'][value='${item.type}']`);
						if ($input.length) {
							$input.prop("checked", true);
						}
					});
				}
			});

			// adding change listeners to the email subscription inputs.
			$form.find("[name][type='checkbox']").change((event) => {
				if (!event || !event.target) {
					return;
				}
				$(event.target).toggleClass("isDirty");
			});
		}
	},

	submitAccountEmailSubscriptions: function (event) {
		event = this._getEventOrReturn(event, "My Email Subscriptions Update action called successfully.");
		if (!event) {
			return;
		}

		var $component,
			$form,
			$namedInputs;

		event.preventDefault();
		event.stopPropagation();

		$form = $(event.target);
		if ($form[0].tagName !== "FORM") {
			return false;
		}
		if (this.isAccountEmailSubscriptionsSaving) {
			console.log("Already Saving, Skipping.");
			return;
		} else {
			this.isAccountEmailSubscriptionsSaving = true;
		}

		$component = $form.closest("[data-component='myEmailSubscriptions']");
		$namedInputs = $component.find("[name].isDirty");

		// nothing to update
		if (!$namedInputs.length) {
			this.isAccountEmailSubscriptionsSaving = false;
			return false;
		}

		// Iterate over each changed subscription and attempt to subscribe/unsubscribe.
		// * If we succeed, find the input and remove the isDirty class.
		// * If we failed, find the input and:
		//	* Remove the isDirty class
		//	* Toggle the checked state (back to what it was previously)
		//	* Add the subscription type to a list of failed subscription types to alert user.
		Spinner.showSpinner($component);
		var failedSubscriptions = [];

		var failureCallback = function ($input, subscriptionType) {
			failedSubscriptions.push(subscriptionType);
			$input.prop("checked", !$input.prop("checked"));
		};

		var alwaysCallback = function ($input, asyncCallback) {
			$input.toggleClass("isDirty");
			asyncCallback();
		};

		async.each($namedInputs, (input, next) => {
			var $input = $(input);
			var subscriptionType = $input.attr("name");
			var isSubscribing = $input.prop("checked");

			if (isSubscribing) {
				// handle subscribe
				EmailSubscriptionApi.subscribe(subscriptionType)
					.fail(() => failureCallback($input, subscriptionType))
					.always(() => alwaysCallback($input, next));
			} else {
				// handle unsubscribe
				EmailSubscriptionApi.unsubscribe(subscriptionType)
					.fail(() => failureCallback($input, subscriptionType))
					.always(() => alwaysCallback($input, next));
			}
		}, () => {
			Spinner.removeSpinner($component);
			this.isAccountEmailSubscriptionsSaving = false;
			if (failedSubscriptions.length) {
				var typesModelString = $component
					.find("[data-component='emailSubscriptionTypes']")
					.attr("data-email-subscription-types-model") || "{}";

				var typesModel = JSON.parse(typesModelString);
				var failedSubscriptionsDisplayString = "";

				failedSubscriptions.forEach(subType => {
					var subTypeDescription = typesModel[`${subType}_Description`];
					failedSubscriptionsDisplayString += `\n${subTypeDescription}`;
				});

				BootstrapPrompt.alert(this.getMyEmailSubscriptionError(`\n${failedSubscriptionsDisplayString}\n\n`));
			} else {
				SubmitButtonHelper.performPostSubmitAction("[data-component='myEmailSubscriptions']");
			}
		});
	},

	submitEmailSubscriptionRequest(event) {
		event = this._getEventOrReturn(event, "Email Subscription Process action called successfully.");
		if (!event) {
			return;
		}

		var $accountForm,
			$emailSubscriptionForm,
			$form,
			$namedInputs,
			defaultEmailSubscriptionType;

		event.preventDefault();
		event.stopPropagation();

		$form = $(event.target);
		if ($form[0].tagName !== "FORM") {
			return false;
		}
		if (this.isAccountEmailSubscriptionsSaving) {
			console.log("Already Saving, Skipping.");
			return;
		} else {
			this.isAccountEmailSubscriptionsSaving = true;
		}

		$emailSubscriptionForm = $form.closest("[data-component='emailSubscriptionForm']");
		$accountForm = $emailSubscriptionForm.find("[data-component='createAccountForm']");
		$namedInputs = $emailSubscriptionForm.find("[name].isDirty,[name][required]");
		defaultEmailSubscriptionType = $emailSubscriptionForm.attr("data-default-email-subscription-type");

		// This block checks to ensure that we either have at least one selected email subscription type
		// (if the types component is on the page), or that the default email subscription type has been
		// set on the form.
		if ($namedInputs.length <= 0 && !defaultEmailSubscriptionType) {
			LoggerInstance.error("Need to set default email subscription type, or select at least one email subscription type.");
			this.isAccountEmailSubscriptionsSaving = false;
			return false;
		}

		// Custom validation.
		$emailSubscriptionForm.find('[data-component="emailSubscriptionTypes"][required]').each((index, eachComponent) => {
			if (!$(eachComponent).find("input:checked").length) {
				ValidationHelper.showInvalidInputsDialog();
				this.isAccountEmailSubscriptionsSaving = false;
				return;
			}
		});

		var components = [
			$emailSubscriptionForm
		];

		Spinner.showSpinner($emailSubscriptionForm);
		ValidationHelper.validate({ components }).always(isValid => {
			if (!isValid) {
				Spinner.removeSpinner($emailSubscriptionForm);
				this.isAccountEmailSubscriptionsSaving = false;
				return;
			}

			var accountData = AccountFormHelper.serializeCreateAccountFormOnly({
				accountFormId: $accountForm.attr("id"),
				createAddressIfNotExists: true,
				shouldEncodePassed: false
			});

			// check to see if we were given a source code. We need to pass this in manually to handle the
			// scenario where 3rd party or all cookies are disabled and we're trying to process an email
			// subscription widget.
			var sourceCode = HistoryHelper.getQueryObject().source;

			// Default account type like we do when creating accounts through the AccountApi.
			accountData.type = AccountApi.getAccountType(accountData);
			accountData.source = sourceCode;

			// Build list of email subscriptions to add based on components on the page.
			var subscriptionTypesToProcess = [];
			var defaultSubscriptionType = $emailSubscriptionForm.attr("data-default-email-subscription-type");
			var $multipleSubscriptionTypes = $emailSubscriptionForm.find("input[data-component='emailSubscriptionTypes.singleCheckbox.input']");

			if ($multipleSubscriptionTypes.length) {
				$multipleSubscriptionTypes.each((index, eachItem) => {
					var $eachItem = $(eachItem);
					if ($eachItem.is(":checked")) {
						subscriptionTypesToProcess.push($eachItem.val());
					}
				});
			} else if (defaultSubscriptionType) {
				subscriptionTypesToProcess.push(defaultSubscriptionType);
			} else {
				LoggerInstance.debug("No default email subscription selected for this form, and no subscription type selector present.");
			}

			if (subscriptionTypesToProcess.length) {
				EmailSubscriptionApi.submitEmailSubscriptionRequest({
					account: accountData,
					sourceCode: sourceCode,
					subscriptionTypes: subscriptionTypesToProcess
				}).done(() => {
					SubmitButtonHelper.performPostSubmitAction(`[data-component='emailSubscriptionForm'][id='${$emailSubscriptionForm.attr("id")}']`);
				}).fail((err) => {
					var errorMessage;
					if (err && err.responseJSON && err.responseJSON.safeToDisplay === true && err.responseJSON.message) {
						errorMessage = err.responseJSON.message;
					} else if (err) {
						errorMessage = this.getEmailSubscriptionFormError()
					}
					BootstrapPrompt.alert(errorMessage);
				}).always(() => {
					Spinner.removeSpinner($emailSubscriptionForm);
					this.isAccountEmailSubscriptionsSaving = false;
				});
			} else {
				Spinner.removeSpinner($emailSubscriptionForm);
				this.isAccountEmailSubscriptionsSaving = false;
			}
		});

		return false;
	},

	updateSelectedCheckboxes: function ($selectedCheckbox, isChecked) {
		var $currentComponent = $selectedCheckbox.closest('[data-component="emailSubscriptionTypes.singleCheckbox"]');
		if (isChecked) {
			$currentComponent.addClass("selected");
			$currentComponent.find("label").addClass("selected");
		} else {
			$currentComponent.removeClass("selected");
			$currentComponent.find("label").removeClass("selected");
		}
	},

	_getEventOrReturn: function (event, isDesignModeMessage) {
		return ActionsHelper.getEventOrReturn(event, EmailSubscriptionStore.get("isDesignMode"), isDesignModeMessage);
	}
};

module.exports = EmailSubscriptionActions;
